import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const activateEmailApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    emailActivate: builder.mutation({
      query: credentials => ({
        url: '/appmanagement/optimize/v1/public/user/activation/activate',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: response => response,
      invalidatesTags: [{ type: 'existingEmail', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});
